//import Password from './Password'
//import { Mailer } from 'nodemailer-react'
import Environment from '../../../constants/environment';
import React from "react";
import Reflux from "reflux";
import { withApollo } from "react-apollo";
import { Card, CardHeader, CardTitle, CardBody, Form, ListGroup, ListGroupItem, Input, Row, Table, FormText, Col, Label, Button, UncontrolledTooltip } from "reactstrap";
import { Bar,  HorizontalBar  } from "react-chartjs-2";
import SipsTable from "../../../components/Sips/SipsTable";
import LoadingOverlay from "react-loading-overlay";
import RateGasInformation from "../../../components/Cards/RateGasInformationDocument";
import { VIEW_SIPSGAS } from "../../../queries/sips/sipsGas.graphql";
import GetUserData from "../../../components/User/GetUserData";
import { UserStore } from "../../../store/UserStore";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../../assets/scss/documento.scss";
import DataTable from 'react-data-table-component';
import axios from 'axios';
//const nodemailer = require("nodemailer");
//import { Mailer } from 'nodemailer-react'

//import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const columnsDatosPropuesta = [
  {selector: row => row['periodo']  , name: 'PERIODO', sortable: false, width: '80px', style: {
      color: 'rgba(0,0,0,.54)',
    },},
  {selector: row => row['precioPotencia'] , name: 'PRECIO TF €/mes', sortable: false, width: '140px', center: true},
  {selector: row => row['precioEnergia']  , name: 'PRECIO TE €/KWH', width: '140px', sortable: false, center: true},
  {selector: row => row['coeficiente']  , name: 'CoeficienteK', width: '140px', sortable: false, center: true},
];

const columnsDatosPropuestaActual = [
  {selector: row => row['periodo'] , name: 'PERIODO', sortable: false, width: '80px', style: {
      color: 'rgba(0,0,0,.54)',
    },},
  {selector: row => row['precioPotencia'] , name: 'PRECIO TF €/mes', sortable: false, width: '140px', center: true},
{selector: row => row['precioEnergia'] , name: 'PRECIO TE €/KWH', width: '140px', sortable: false, center: true},
{selector: row => row['coeficiente']  , name: 'CoeficienteK', width: '140px', sortable: false, center: true},
];

const notify = () => toast.success(
    "Correo enviado correctamente",
    {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

const notifyError = () => toast.error(
    "Existe un problema con el servicio de correos",
    {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

const notifyEnvio = () => toast.info(
    "Preparando el fichero para su envío por correo",
    {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

const comercialProductoFields = {
    periodo: "Periodo",
    precioPotencia: "Precio Termino Fijo €/mes",
    precioEnergia: "Precio Termino Energía €/kWh"
};

const comercialProductoExpandableFields = {};

const customStyles = {
	headRow: {
		style: {
			border: 'none',

		},
	},
	headCells: {
		style: {
			color: '#202124',
			fontSize: '12px',
      fontWeight: 'bold',
      wordBreak: 'break-word',
      paddingLeft: '8px',
      paddingRight: '8px',
      minWidth: '55px'

		},
	},
  cells: {
  style: {
    paddingLeft: '8px',
    paddingRight: '8px',
    minWidth: '55px',
    wordBreak: 'break-word',
    fontFamily: '"Open Sans", sans-serif;'
  },
},
	rows: {
		highlightOnHoverStyle: {
			backgroundColor: 'rgb(230, 250, 250)',
			borderBottomColor: '#FFFFFF',
			borderRadius: '25px',
			outline: '1px solid #FFFFFF',
      fontSize: '12px',
		},
	},
	pagination: {
		style: {
			border: 'none',
		},
	},
};



//const container = React.useRef<HTMLDivElement>(null);
//  const pdfExportComponent = React.useRef<PDFExport>(null);
/*  const exportPDFWithMethod = () => {
    let element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      margin: 40,
      fileName: `Report for ${new Date().getFullYear()}`,
    });
  };
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
*/





class ComercialGasProductoDocumento extends Reflux.Component {
    public container: any = null;
    public fileInput: any = null;
    public pdfExportComponent: any = null;
    public formActualRef: any = null;
    public formProductoRef: any = null;
    public datosContrato: any = null;
    //public datosPropuestaTest: any =null
    public state: any = {
        id: "",
        compania:"",
        // --- Data
        formProducto: {
            serviciosAdicionales: 0,
            alquilerEquipoMedida: 0,

            sumPotencia: 0,
            sumEnergia: 0,
            factork:0,
            iePercent: 0,
            impuestoElectrico: 0,
            iva: 0,
            bi: 0,
            total: 0,

        },
        formActual: {

            serviciosAdicionales: 0,
            alquilerEquipoMedida: 0,

            sumPotencia: 0,
            sumEnergia: 0,
            iePercent: 0,
            impuestoElectrico: 0,
            iva: 0,
            bi: 0,
            total: 0,


            precioTP1: 0,
            precioTP2: 0,

            precioTEP1: 0,
            precioTEP2: 0,
            factork: 0

        },
        totalComparacion: {
            ahorroAnual: 0,
            ahorroPercent: 0,
            ahorroPeriodo: 0
        },
        isLoading: true,
        sip: {},

        periods: [],
        itemsTabla: [],
        itemsTablaActual:[],
        producto: {},
        costeOperativo: 0,
        correoContacto: '',
        nombreFichero: '',
        datafile: "",
        uploadedFileContents: null,
        control:0,
        datosPropuestaTest: {itemsPeriodos:[]},
        productoTarifas: {},
        datosPropuestaComercial:{}
        //paginatedData: {items:[{CIF:''}]},


    };

    constructor(props) {
        super(props);
        this.store = UserStore;


        this.container = React.createRef<HTMLDivElement>();
        this.pdfExportComponent = React.createRef<PDFExport>();
        this.fileInput = React.createRef();
    }


  componentDidMount() {

        this.formActualRef = React.createRef();
        this.formProductoRef = React.createRef();
        const {
            match: { params },
        } = this.props;

        const user = localStorage.getItem("user");

        if (user) {
            const parsed = JSON.parse(user);
            this.setState({ user: parsed });
        }

        this.setState({
            ...this.state,
            id: params.id,
            compania: params.compania
        },
            this.fetchComparativaLibre
        );

        this.setState({

            control: 1}
        );

    }


    exportPDFWithMethod = () => {
        let element = this.container.current || document.body;
        savePDF(element, {
            paperSize: "auto",
            margin: 40,
            fileName: `Propuesta_Gas_${new Date().getFullYear()}`,
        });
    };

    exportPDFWithComponentclick = () => {
        if (this.pdfExportComponent.current) {
            this.pdfExportComponent.current.save();
        }
    };

    //SendEmail = async (e: React.ChangeEvent<HTMLInputElement>)  => {
    SendEmail = async (event) => {
        event.persist()
        console.log('Valor del Fichero')
        console.log(event.target.files);
        var selectedFile: any = []
        var evento: any = []
        if (event !== null && event.target.files !== null) {
            selectedFile = event.target.files;
            evento = event
            var fileContents: string = ""

        }

        var file: string | ArrayBuffer = '';
        var fileName = "";
        if (selectedFile.length > 0) {
            let fileToLoad = selectedFile[0];
            try {
                const fileContents = await this.readUploadedFileAsText(fileToLoad)
                this.setState({
                    uploadedFileContents: fileContents
                });
            } catch (e) {
                console.warn(e.message)
            }


            /*
                   fileName = fileToLoad.name;
                   const fileReader = new FileReader();
                  // Onload of file read the file content
                  //    if(event!=null && event.target.files != null) {

          if(event!==null && event) {
                 fileReader.onload = function(event: Event) {
                //  if(evento!=null) {
                //console.log(this.result)
                const file64 =  event!==null?fileReader.result:""
                console.log(file64)
                file = file64!== null?file64:""
                      //file = e.target.result;
                      // Print data in console


                 }
                 this.setState({
                   datafile: file
                 })
               }
                 var pdf64 = fileReader.readAsDataURL(fileToLoad);

                 */
        }

        //let fileName = this.fileInput.current.files[0].name;
        //let fileReader = new FileReader();
        /*      fileReader.onload = function(fileLoadedEvent) {
                    file = fileLoadedEvent.target.result;
                    // Print data in console
                    console.log(file);
                };
                fileReader.readAsDataURL(fileToLoad);
        */
        var templateParams = {
            to_name: this.state.correoContacto,
            from_name: this.state.producto.nombreComercializadora,
            producto: this.state.producto.nombreOferta,
            cup: this.state.cups,
            correoContacto: this.state.correoContacto,
            nombrePropuesta: this.state.nombreFichero + ".pdf",
            variable_myhirj5: this.state.uploadedFileContents
        }

        notifyEnvio();


        emailjs.send("service_dynargyMail", "template_ctuhpkd", templateParams, "user_9fdpYny52CeShK5yj0B3u")
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
                notify();
            }, function (error) {
                console.log('FAILED...', error);
                notifyError();
            });;



    };

    readUploadedFileAsText = (inputFile) => {

        const temporaryFileReader = new FileReader();

        return new Promise((resolve, reject) => {
            temporaryFileReader.onerror = () => {
                temporaryFileReader.abort();
                reject(new DOMException("Problem parsing input file."));
            };

            temporaryFileReader.onload = () => {
                resolve(temporaryFileReader.result);
            };
            //temporaryFileReader.readAsText(inputFile);
            temporaryFileReader.readAsDataURL(inputFile);
        });
    };



    fetchSip = async () => {

        await this.props.client
            .query({
                query: VIEW_SIPSGAS,
                variables: { cups: this.state.cups },
            })
            .then((result) => {
                //Sip
                const sip = result.data.viewSipsGas[0];
                this.setState({
                    ...this.state,
                    sip: sip,
                    isLoading: false,
                });
            });
    }



    fetchComparativaLibre = async () => {

        var dataFilters = {
            'compania': "",
            'cups': "",
            'Usuario': "",
            'NIF': "",
            'IdOferta': this.state.id
        };


        var companyIdUser = this.state.compania
        var userIdAux = "0"

        const valores = JSON.stringify(dataFilters)
        const headers = {
            'Authorization': 'Bearer my-token',
            'My-Custom-Header': 'foobar',
            'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
        };
        let direccionFile = "https://datapi.psgestion.es/propuesta/listado?id=" +companyIdUser+"&user="+userIdAux;

        axios.get(direccionFile, { headers, params: { valores } }).
            then(result => {

                let data = result.data.rows[0];
                let datosPreciosActual = data.T_Propuesta.actual;
                let datosPropuesta = data.T_Propuesta.producto;
                let datosContrato = result.data.rows[0];
                let datosPropuestaComercial=data.T_PropuestaComercial
                let test2 = data.T_Propuesta.producto

        if(datosContrato.OfertaTipo == "P"){

                let formActual = datosPreciosActual.datos


                        var itemsTablaActual:any=[];

                        itemsTablaActual[0] = {'periodo':'P1','precioEnergia':formActual.precioTEP1,'precioPotencia':formActual.precioTP1, 'coeficiente':formActual.factork};
                        //itemsTablaActual[1] = {'periodo':'P2','precioEnergia':formActual.precioTEP2,'precioPotencia':formActual.precioTP2};

                        let formProducto = test2.datos


                        var itemsTabla:any=[];

                        itemsTabla[0] = {'periodo':'P1','precioEnergia':formProducto.precioTEP1?formProducto.precioTEP1:0,'precioPotencia':formProducto.precioTP1?formProducto.precioTP1:0, 'coeficiente':formProducto.factork};
                        //itemsTablaActual[1] = {'periodo':'P2','precioEnergia':formActual.precioTEP2,'precioPotencia':formActual.precioTP2};



                let nombreFichero = 'Propuesta_' + data.cups + (new Date().getFullYear()).toString();
                this.setState({
                    ...this.state,
                    formProducto: datosPropuesta.datos,
                    formActual: datosPreciosActual.datos,
                    totalComparacion: datosPropuesta.totalComparacion,
                    cups: data.cups,
                    periods: datosPropuesta.periodos,
                    itemsTabla: itemsTabla,
                    itemsTablaActual: itemsTablaActual,
                    producto: datosPropuesta.producto,
                    productoTarifas: datosPropuesta.producto,
                    costeOperativo: datosPropuesta.costeOperativo,
                    costeOperativoPotencia: datosPropuesta.costeOperativoPotencia,
                    correoContacto: data.correoContacto,
                    nombreFichero: nombreFichero,
                    datosContrato: datosContrato,
                    datosPropuestaTest: datosPropuesta,
                     datosPropuestaComercial: datosPropuestaComercial
                },
                    this.fetchSip)
                }else if(datosContrato.OfertaTipo == "MP"){

                                    let nombreFichero = 'Propuesta_' + data.cups + (new Date().getFullYear()).toString();


                                    this.setState({
                                        ...this.state,
                                        formProducto: datosPropuesta.datos,
                                        totalComparacion: datosPropuesta.totalComparacion,
                                        cups: data.cups,
                                        periods: datosPropuesta.periodos,
                                        itemsTabla: datosPropuesta.itemsPeriodos,
                                        itemsTablaActual: itemsTablaActual,
                                        producto: datosContrato.T_PropuestaComercial,
                                        productoTarifas: datosContrato.T_PropuestaComercialDatosIndividual,
                                        costeOperativo: datosContrato.T_PropuestaComercial.GastoOperativo,
                                        costeOperativoPotencia:datosContrato.T_PropuestaComercial.GastoOperativoPotencia,
                                        correoContacto: data.correoContacto,
                                        nombreFichero: nombreFichero,
                                        datosContrato: datosContrato,
                                        datosPropuestaTest: datosPropuesta
                                    },
                                    this.fetchSip)


                                }

                            }).catch(function() {
                                console.log('Failure')
                                //notifyErrorDB();

            });

    };

/////////////////////////////////////////////////////////////////////////////////

tipoPrecio= (props) => {

    const tipoTarifa = props.tipoPrecio;
    const totalComparacion = props.totalComparacion
    const producto = props.producto
    const styleFullWith = { "width": "100%" };
    if (tipoTarifa === '1') {
return (
    <Row>
        <Col>
            <CardTitle className="mt-4 info-title"><h2>Resumen producto {producto.nombreOferta}</h2></CardTitle>
            <Row>
                <Col><strong>El precio del kWh de consumo se calcula a partir del precio medio del periodo de facturación del MIBGAS por el consumo realizado y un coeficiente corrector</strong></Col>
            </Row>
            <Row className="mt-2">
                <Col><strong>Coeficiente K: </strong><br></br>{totalComparacion.factork}</Col>
            </Row>
            <Row className="mt-2">
                <Col><strong>Comercializadora: </strong><br></br>{producto.nombreComercializadora}</Col>
                <Col><strong>Producto: </strong><br></br>{producto.nombreOferta}</Col>
            </Row>
        </Col>
    </Row>
)
} else {
return (
    <Row>
        <Col>
            <CardTitle className="mt-4 info-title"><h2>Resumen producto {producto.nombreOferta}</h2></CardTitle>
            <Row>
                <Col><strong>Precio Término Fijo €/mes: </strong><br></br>{producto.precioTFijo}</Col>
                <Col><strong>Precio Término Energía kWh P1: </strong><br></br>{producto.precioTE1}</Col>
                <Col><strong>Consumo Mínimo Gas: </strong><br></br>{producto.consumoMinimoGas}</Col>
                <Col><strong>Consumo Máximo Gas: </strong><br></br>{producto.consumoMaximoGas}</Col>
                <Col><strong>Tarifa ATR: </strong><br></br>{producto.tarifaATR}</Col>

            </Row>
            <Row className="mt-2">
                <Col><strong>Comercializadora: </strong><br></br>{producto.nombreComercializadora}</Col>
                <Col><strong>Producto: </strong><br></br>{producto.nombreOferta}</Col>
            </Row>
        </Col>
    </Row>
)
};
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

graficoAhorro = (props) => {

const tipoTarifa = props.tipoPrecio;
const data = props.data
const options = props.options


    if (tipoTarifa === '1') {
        return (

                <Card className="mt-3 mb-3 p-3 card-document">
                    <h2 className='title'>Costes sin impuestos</h2>
                    <div>
                        <Bar data={data} width={80} height={40} options={options} />
                    </div>
                </Card>

                )
        } else {
        return (

                <Card className="mt-3 mb-3 p-3 card-document">
                    <h2 className='title'>Costes sin impuestos</h2>
                    <div>
                        <Bar data={data} width={80} height={40} options={options} />
                    </div>
                </Card>

                )
    };
};
/////////////////////////////////////////////////////////////////////////////////

//<this.tablaCostes tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTabla} />
//<this.tablaCostes tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTabla} columns={columnsDatosPropuesta} style={customStyles}/>


tablaCostes= (props) => {

    const tipoTarifa = props.tipoPrecio;
    const columns = props.columns
    const data = props.dataColumns
    const customStyles = props.style
    const formProducto = props.producto


        if (tipoTarifa === '1') {
return (
<React.Fragment>
<Row>
  <DataTable

       columns={columns}
       data = {data}
       fixedHeader = {true}
       striped
       pointerOnHover
       customStyles={customStyles}
       noDataComponent = {"Sin datos para mostrar"}

     />

</Row>
<Row className="panel-data-resolve pb-0">
    <div className="col">
        <div className="item-data">
            <h4>Término Energía Consumida</h4>
            <div className="">{formProducto.sumEnergia}€</div>
        </div>

        <div className="item-data">
            <h4 className="">I.E. Hidrocarburos 0,00234 €/kWh</h4>
            <div className="">{formProducto.iePercent}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Servicios Adicionales</h4>
            <div className="">{formProducto.serviciosAdicionales}€</div>
        </div>
        <div className="item-data">
            <h4 className="">IVA 21%</h4>
            <div className="">{formProducto.iva}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Alquiler del Equipo a Medida</h4>
            <div className="">{formProducto.alquilerEquipoMedida}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Base imponible</h4>
            <div className="">{formProducto.bi}€</div>
        </div>
        <div className="item-data bg-total align-middle p-2">
            <h2>Total</h2>
            <div><h2>{formProducto.total}€</h2></div>
        </div>
    </div>
</Row>
</React.Fragment>
)
} else {
return (
<React.Fragment>
    <Row>
      <DataTable

           columns={columns}
           data = {data}
           fixedHeader = {true}
           striped
           pointerOnHover
           customStyles={customStyles}
           noDataComponent = {"Sin datos para mostrar"}

         />

    </Row>
    <Row className="panel-data-resolve pb-0">
        <div className="col">
            <div className="item-data">
                <h4 className="">Término Fijo</h4>
                <div className="">{formProducto.sumPotencia}€</div>
            </div>

            <div className="item-data">
                <h4 className="">I.E. Hidrocarburos 0,00234 €/kWh</h4>
                <div className="">{formProducto.iePercent}€</div>
            </div>
            <div className="item-data">
                <h4 className="">Servicios Adicionales</h4>
                <div className="">{formProducto.serviciosAdicionales}€</div>
            </div>
            <div className="item-data">
                <h4 className="">IVA 21%</h4>
                <div className="">{formProducto.iva}€</div>
            </div>
        {/* </div>
        <div className="col"> */}
            <div className="item-data">
                <h4>Término Energía</h4>
                <div className="">{formProducto.sumEnergia}€</div>
            </div>

            <div className="item-data">
                <h4 className="">Alquiler del Equipo a Medida</h4>
                <div className="">{formProducto.alquilerEquipoMedida}€</div>
            </div>
            <div className="item-data">
                <h4 className="">Base imponible</h4>
                <div className="">{formProducto.bi}€</div>
            </div>
            <div className="item-data bg-total align-middle p-2">
                <h2>Total</h2>
                <div><h2>{formProducto.total}€</h2></div>
            </div>
        </div>
    </Row>
</React.Fragment>
)
}
};

/////////////////////////////////////////////////////////////////////////////////

//<this.tablaCostes tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTabla} />
//<this.tablaCostes tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTabla} columns={columnsDatosPropuesta} style={customStyles}/>


tablaCostesActual= (props) => {

    const tipoTarifa = props.tipoPrecio;
    const columns = props.columns
    const data = props.dataColumns
    const customStyles = props.style
    const formProducto = props.producto


        if (tipoTarifa === '1') {
return (
<React.Fragment>
<Row>
  <DataTable

       columns={columns}
       data = {data}
       fixedHeader = {true}
       striped
       pointerOnHover
       customStyles={customStyles}
       noDataComponent = {"Sin datos para mostrar"}

     />

</Row>
<Row className="panel-data-resolve pb-0">
    <div className="col">
        <div className="item-data">
            <h4>Término Energía Consumida</h4>
            <div className="">{formProducto.sumEnergia}€</div>
        </div>

        <div className="item-data">
            <h4 className="">I.E. Hidrocarburos 0,00234 €/kWh</h4>
            <div className="">{formProducto.iePercent}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Servicios Adicionales</h4>
            <div className="">{formProducto.serviciosAdicionales}€</div>
        </div>
        <div className="item-data">
            <h4 className="">IVA 21%</h4>
            <div className="">{formProducto.iva}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Alquiler del Equipo a Medida</h4>
            <div className="">{formProducto.alquilerEquipoMedida}€</div>
        </div>
        <div className="item-data">
            <h4 className="">Base imponible</h4>
            <div className="">{formProducto.bi}€</div>
        </div>
        <div className="item-data bg-total align-middle p-2">
            <h2>Total</h2>
            <div><h2>{formProducto.total}€</h2></div>
        </div>
    </div>
</Row>
</React.Fragment>
)
} else {
return (
<React.Fragment>
    <Row>
      <DataTable

           columns={columns}
           data = {data}
           fixedHeader = {true}
           striped
           pointerOnHover
           customStyles={customStyles}
           noDataComponent = {"Sin datos para mostrar"}

         />

    </Row>
    <Row className="panel-data-resolve pb-0">
        <div className="col">
            <div className="item-data">
                <h4 className="">Término Fijo</h4>
                <div className="">{formProducto.sumPotencia}€</div>
            </div>

            <div className="item-data">
                <h4 className="">I.E. Hidrocarburos 0,00234 €/kWh</h4>
                <div className="">{formProducto.iePercent}€</div>
            </div>
            <div className="item-data">
                <h4 className="">Servicios Adicionales</h4>
                <div className="">{formProducto.serviciosAdicionales}€</div>
            </div>
            <div className="item-data">
                <h4 className="">IVA 21%</h4>
                <div className="">{formProducto.iva}€</div>
            </div>
        {/* </div>
        <div className="col"> */}
            <div className="item-data">
                <h4>Término Energía</h4>
                <div className="">{formProducto.sumEnergia}€</div>
            </div>

            <div className="item-data">
                <h4 className="">Alquiler del Equipo a Medida</h4>
                <div className="">{formProducto.alquilerEquipoMedida}€</div>
            </div>
            <div className="item-data">
                <h4 className="">Base imponible</h4>
                <div className="">{formProducto.bi}€</div>
            </div>
            <div className="item-data bg-total align-middle p-2">
                <h2>Total</h2>
                <div><h2>{formProducto.total}€</h2></div>
            </div>
        </div>
    </Row>
</React.Fragment>
)
}
};


//////////////////////////////////////////////////////////////////////////////////7
    render() {
        const isLoading = this.state.isLoading;
        const sip = this.state.sip;
        //var itemsTablapro = this.state.datosPropuestaTest.itemsPeriodos;
        const totalComparacion = this.state.totalComparacion;
        const producto = this.state.producto;
        const productoTarifas = this.state.productoTarifas;
        const formActual = this.state.formActual;
        const formProducto = this.state.formProducto;
        const periodos = this.state.periods;
        const cups = this.state.cups;
        const styleFullWith = { "width": "100%" };
        const correoContacto = this.state.correoContacto;
        const datosContrato = this.state.datosContrato;

        //const datosTitular = this.state.datosContrato.T_Titular
        var NIF = ""
        if(this.state.datosContrato){
            NIF = this.state.datosContrato.T_Titular.NIF
            }

        var tipoPrecio = '1'
        if(this.state.datosContrato){
            tipoPrecio = this.state.datosContrato.T_PropuestaComercial.TipoPrecio
            }

        const nombreFichero = this.state.nombreFichero
        //              fileName={`Report for ${cups} ${new Date().getFullYear()}`}

        //PLOTS DATA

        let ofertaTipo = "";
        if(this.state.datosContrato === undefined){
            ofertaTipo = "";
        }else{
            ofertaTipo = this.state.datosContrato.T_PropuestaComercial.TipoPrecio;
        }

        var datasetProducto = [0];

        if(tipoPrecio == '1'){
        datasetProducto.length = 0;
        datasetProducto[datasetProducto.length] = formProducto.sumEnergia;
        datasetProducto[datasetProducto.length] = formProducto.serviciosAdicionales;
        datasetProducto[datasetProducto.length] = formProducto.alquilerEquipoMedida;
        datasetProducto[datasetProducto.length] = formProducto.sumEnergia+formProducto.sumPotencia+formProducto.serviciosAdicionales+formProducto.alquilerEquipoMedida;
        } else {
            datasetProducto[datasetProducto.length] = formProducto.sumEnergia;
            datasetProducto[datasetProducto.length] = formProducto.sumPotencia;
            datasetProducto[datasetProducto.length] = formProducto.serviciosAdicionales;
            datasetProducto[datasetProducto.length] = formProducto.alquilerEquipoMedida;
            datasetProducto[datasetProducto.length] = formProducto.sumEnergia+formProducto.sumPotencia+formProducto.serviciosAdicionales+formProducto.alquilerEquipoMedida;
            }


        var datasetActual = [0];
        if(tipoPrecio == '1'){
        datasetActual.length = 0;
        datasetActual[datasetActual.length] = formActual.sumEnergia;
        datasetActual[datasetActual.length] = formActual.serviciosAdicionales;
        datasetActual[datasetActual.length] = formActual.alquilerEquipoMedida;
        datasetActual[datasetActual.length] = formActual.sumEnergia+formActual.sumPotencia+formActual.serviciosAdicionales+formActual.alquilerEquipoMedida;

} else {

    datasetActual.length = 0;
    datasetActual[datasetActual.length] = formActual.sumEnergia;
    datasetActual[datasetActual.length] = formActual.sumPotencia;
    datasetActual[datasetActual.length] = formActual.serviciosAdicionales;
    datasetActual[datasetActual.length] = formActual.alquilerEquipoMedida;
    datasetActual[datasetActual.length] = formActual.sumEnergia+formActual.sumPotencia+formActual.serviciosAdicionales+formActual.alquilerEquipoMedida;

}
        var datasetAhorro=this.state.totalComparacion.datosAhorro;
        var data ={};

        if(tipoPrecio == '1'){

            data = {
                labels: ['Coste Energía', 'Costes Servicios', 'Costes Equipos', 'Total'],
                datasets: [
                    {
                        label: 'Resumen Producto Ofertado',
                        data: datasetProducto,
                        backgroundColor: 'rgb(255, 99, 132)',
                    },
                    {
                        label: 'Resumen Factura Actual',
                        data: datasetActual,
                        backgroundColor: 'rgb(54, 162, 235)',
                    },
                ],
            }


            } else {

                data = {
                    labels: ['Coste Energía', 'Costes T. Fijo', 'Costes Servicios', 'Costes Equipos', 'Total'],
                    datasets: [
                        {
                            label: 'Resumen Producto Ofertado',
                            data: datasetProducto,
                            backgroundColor: 'rgb(255, 99, 132)',
                        },
                        {
                            label: 'Resumen Factura Actual',
                            data: datasetActual,
                            backgroundColor: 'rgb(54, 162, 235)',
                        },
                    ],
                }

            };




        const dataAhorro = {
            labels: ['Total Coste Actual', 'Total Propuesta', 'Ahorro'],
            datasets: [
                {
                    label: 'Resumen de coste',
                    data: datasetAhorro,
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)',
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)',
                    ],
                    borderWidth: 1,
                },
            ],
        }

        const options = {
            maintainAspectRatio: true,
            legend: {
                display: true,
                labels: {
                    fontColor: 'rgb(255, 99, 132)'
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
        }


        return (
            <>
                <GetUserData></GetUserData>

                <Row className="card-deck mb-3">
                    <Card id="supplyInformation" className={this.props.cardClass}>
                        <CardBody className="p-4">
                            <Row>
                                <Col md="2">
                                    <div className="col">

                                        <CardBody>
                                            <Button className="btn-icon" color="primary" type="button" id="imprimirProptooltip" onClick={this.exportPDFWithComponentclick} >
                                                <span className="btn-inner--icon mr-1">
                                                    <i className="fas fa-file-pdf fa-3x" />
                                                </span>
                                                <span className="btn-inner--text">Exportar PDF</span>
                                                <UncontrolledTooltip delay={0} placement="top" target="imprimirProptooltip">
                                                    EXPORTAR PDF
                                                </UncontrolledTooltip>
                                            </Button>
                                        </CardBody>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="col">
                                        <CardBody>
                                            <Form>
                                                <div className="custom-file">
                                                    <input
                                                        className="custom-file-input lg"
                                                        id="customFileLang"
                                                        lang="es"
                                                        type="file"
                                                        ref={this.fileInput}
                                                        onChange={this.SendEmail}
                                                    />
                                                    <FormText color="muted">
                                                        Seleccionar propuesta para su envío por correo electrónico
                                                    </FormText>
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Row>

                <PDFExport
                    ref={this.pdfExportComponent}
                    paperSize="auto"
                    margin={40}
                    fileName={`${nombreFichero}`}
                    author="PsGestion"
                >
                    <div id="document-page" ref={this.container} className="border p-4 mb-5 shadow">
                        <LoadingOverlay
                            active={isLoading}
                            spinner
                            text="Cargando...">

  <Row className="row-grid align-items-center">
                      <Col className="order-md-2" md="4">
                        <img
                            alt=''
                            className="img-fluid"
                            src={
                            this.state.UserStore.data.app_logo
                                ? this.state.UserStore.data.app_logo
                                : require("../../../assets/img/brand/dynargy_logo_verde_h.png")
                            }
                        />
                      </Col>
                    </Row>
                                <h1 className="mt-5 ml-5 mr-5 mb-4">Documento resumen producto: {producto.nombreOferta}</h1>

                            <Row className="">
                                <p className="ml-5 mb-3">
                                    Hola!<br></br>
                                    Gracias por confiar en nuestro servicio. A continuación le mostramos los datos más relevantes de la propuesta realizada por uno de nuestros agentes.
                                </p>
                            </Row>

                            <Row className="card-deck" style={styleFullWith}>
                                <Card className="mt-3 mb-3 p-3 card-document">
                                    <CardBody>
                                        <Row>
                                            <Col md="6">
                                                <CardTitle className="info-title"><h2>Información del suministro</h2></CardTitle>
                                                <ListGroup>
                                                    <ListGroupItem className="list-item-documento"><strong>CUPS:</strong> {sip.cups}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Titular:</strong> {sip.nombreTitular +' '+sip.apellido1Titular+' '+sip.apellido2Titularr}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>NIF/CIF:</strong> {NIF}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Direccion:</strong> {sip.tipoViaPS+' '+ sip.viaPS+' '+sip.numFincaPS+' '+sip.portalPS+ ' '+sip.pisoPS+ ' '+sip.puertaPS}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Provincia:</strong> {sip.desProvinciaPS}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Localidad:</strong> {sip.desMunicipioPS}</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Consumo Anual:</strong> {sip.ConsumoAnualTotal} Kw</ListGroupItem>
                                                    <ListGroupItem className="list-item-documento"><strong>Tarifa actual:</strong> {sip.codigoPeajeEnVigor}</ListGroupItem>
                                                </ListGroup>
                                            </Col>
                                            <Col md="6">
                                            <CardTitle className="info-title"><h2>Consumos punto suministro</h2></CardTitle>
                                                <RateGasInformation
                                                    isLoading={isLoading}
                                                    sip={sip}
                                                    cardClass="col-6 card-document">
                                                </RateGasInformation>
                                            </Col>
                                        </Row>

                                        <this.tipoPrecio tipoPrecio={ofertaTipo} totalComparacion={formProducto} producto={productoTarifas} />

                                        </CardBody>
                                </Card>
                            </Row>


                            <Row className="card-deck w-100">
                                <Card style={styleFullWith} className="mt-3 mb-3 card-document">
                                    <CardBody>
                                        <Row className="">
                                            <h1 className="col">
                                                Resumen ahorros
                                            </h1>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col className="col-auto pt-2 pb-2 mr-2">
                                                <h2>Ahorro periodo seleccionado:</h2>
                                            </Col>

                                            <Col className="col-auto mr-2 d-flex bg-energia radius-pot text-center align-items-center">
                                                <h3 className="mt-2 mb-2 justify-content-center align-self-center text-center">{totalComparacion.ahorroPeriodo}€</h3>
                                            </Col>

                                            <Col className="col-auto d-flex bg-units radius-pot text-center align-items-center">
                                                <h3 className="mt-2 mb-2 justify-content-center align-self-center text-center">{totalComparacion.ahorroPercent}%</h3>
                                            </Col>

                                            <Col className="col-auto pt-2 pb-2 ml-6">
                                                <h2>Ahorro anual:</h2>
                                            </Col>

                                            <Col className="col-auto d-flex bg-energia radius-pot text-center align-items-center">
                                                <h3 className="mt-2 mb-2 justify-content-center align-self-center">{totalComparacion.ahorroAnual}€</h3>
                                            </Col>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Row>

                            <Row className="card-deck" style={styleFullWith}>

                                <this.graficoAhorro tipoPrecio={ofertaTipo} data={data} options={options} />


                                <Card className="mt-3 mb-3 p-3 card-document">
                                    <h2 className='title'>Resumen costes</h2>
                                    <div>
                                        <Bar data={dataAhorro} width={80} height={40} options={options} />
                                    </div>
                                </Card>
                            </Row>


                            <Row className="card-deck" style={styleFullWith}>

                                <Card className="mt-3 mb-3 card-billing-documento card-document">
                                    <Form innerRef={this.formProductoRef}>
                                        <CardBody>
                                            <Row className="">
                                                <h2 className="col">
                                                    Facturación {producto.nombreOferta}
                                                </h2>
                                            </Row>

                                            <this.tablaCostes tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTabla} columns={columnsDatosPropuesta} style={customStyles} producto={formProducto}/>


                                        </CardBody>
                                    </Form>
                                </Card>

                                <Card className="mt-3 mb-3 card-billing-documento card-document">
                                    <Form innerRef={this.formActualRef}>
                                        <CardBody>
                                            <Row className="">
                                                <h2 className="col">
                                                    Facturación comercializadora actual
                                                </h2>
                                            </Row>

                                            <this.tablaCostesActual tipoPrecio={ofertaTipo} dataColumns={this.state.itemsTablaActual} columns={columnsDatosPropuestaActual} style={customStyles} producto={formActual}/>

                                        </CardBody>
                                    </Form>
                                </Card>

                            </Row>

                            <Row className="m-3 border-top">
                                <p className="float-right text-right mt-2">@ PsGestion</p>
                                <p>
                                <small>
                                    Los precios del producto que se muestran en este documento son vigentes para el próximo mes a partir de la fecha de la propuesta. Se han calculado en base a los datos existentes de consumos suministrados por las distribuidoras eléctricas, las comercializadoras y el cliente, si no se especifica de otro modo. Estos cálculos son orientativos y pueden sufrir variaciones ajenas al agente.
                                    <br></br>
                                    Las opciones de pago y de cancelación dependen de las condiciones particulares de la comercializadora elegída. Comprueba sus condiciones antes de reservar.
                                    <br></br>
                                    Te recordamos que estos e-mails son automáticos: no los respondas, por favor.
                                </small>
                                </p>
                            </Row>

                        </LoadingOverlay>
                    </div>
                </PDFExport>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </>
        );
    }
}

export default withApollo(ComercialGasProductoDocumento);
